export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9773.ca47b4b7.jpg";